import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import InstallBanner from "@/components/InstallBanner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import PublicSign from "@/pages/PublicSign";
import PublicRenew from "@/pages/PublicRenew";
import { Privacy, Terms } from "@/pages/Legal";
import Landing from "@/pages/Landing";
import PublicFleet from "@/pages/PublicFleet";
import PublicBook from "@/pages/PublicBook";
import AppShell from "@/pages/AppShell";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import Vehicles from "@/pages/Vehicles";
import Reservations from "@/pages/Reservations";
import ReservationDetail from "@/pages/ReservationDetail";
import Payments from "@/pages/Payments";
import Tolls from "@/pages/Tolls";
import AgreementDetail, { AgreementsList } from "@/pages/Agreements";
import SmsTemplates from "@/pages/SmsTemplates";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";

function RootRoute() {
  const { user } = useAuth();
  if (user === undefined) {
    return <div className="min-h-screen grid place-items-center text-sm text-gray-500">Loading…</div>;
  }
  if (user) return <Navigate to="/admin" replace />;
  return <Landing />;
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return <div className="min-h-screen grid place-items-center text-sm text-gray-500">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public marketing + booking */}
          <Route path="/" element={<RootRoute />} />
          <Route path="/fleet" element={<PublicFleet />} />
          <Route path="/book/:id" element={<PublicBook />} />
          <Route path="/sign/:token" element={<PublicSign />} />
          <Route path="/renew/:token" element={<PublicRenew />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/login" element={<Login />} />

          {/* Protected CRM */}
          <Route
            path="/admin"
            element={
              <Protected>
                <AppShell />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="customers" element={<Customers />} />
            <Route path="vehicles" element={<Vehicles />} />
            <Route path="reservations" element={<Reservations />} />
            <Route path="reservations/:rid" element={<ReservationDetail />} />
            <Route path="payments" element={<Payments />} />
            <Route path="tolls" element={<Tolls />} />
            <Route path="agreements" element={<AgreementsList />} />
            <Route path="agreements/:rid" element={<AgreementDetail />} />
            <Route path="sms" element={<SmsTemplates />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <InstallBanner />
    </AuthProvider>
  );
}

export default App;
